'use strict';

import Component from '_core_ext/components/Component';
import util from '_core_ext/util';

export default class NavigationMenu extends Component {
    init() {
        super.init();
        this.initCache();

        this.event('mouseover', this.cache.rootClassSelector, this.onRootHover);
        this.event('mouseout', this.onMouseOut);

        $('.js-mobile-menu').on('keydown', (e) => this.handleKeydown(e));
        $('.js-mobile-menu').on('keyup', (e) => {
            if (e.key === 'Tab') {
                const activeElement = document.activeElement;
                const activeIndex = this.getActiveMenuIndex(this.cache.rootMenuItems, activeElement);

                if (activeIndex !== -1) {
                    this.updateFlattenMenu(activeElement);
                    this.onRootHover(activeElement.parentNode);
                }
            }
        });
        this.activeMainMenuItem = null;
    }

    initCache() {
        this.cache = {};
        this.cache.rootClassSelector = '.js-root-item';
        this.cache.rootMenuItems = $('.js-mobile-menu-category > ul > li:not(:hidden)')
            .find('.js-root-item > a');
        this.cache.flattenMenu = this._flattenMenu([this.cache.rootMenuItems.get(0)], 'Level1');
    }

    //
    // Component actions.
    //

    onMouseOut() {
        this._hideAllSubMenu();
    }

    onRootHover(element) {
        let subMenu = $(element).children('ul');

        this._hideAllSubMenu();

        if (subMenu.length) {
            subMenu.addClass('is-open');
        }
    }

    //
    // Internally used functions.
    //

    _hideAllSubMenu() {
        this.$el
            .find(this.cache.rootClassSelector)
            .children('ul')
            .removeClass('is-open');
    }

    handleKeydown(e) {
        if (!util.isMobile() || $(window).width() >= 1224) {
            this.mainMenuNavigation(e, document.activeElement);
        }
    }

    // eslint-disable-next-line complexity
    mainMenuNavigation(e, activeElement) {
        let direction = e.shiftKey ? 'previous' : 'next';
        switch (e.key) {
            case 'Escape':
                this.onMouseOut();
                break;
            case 'Tab':
                if (direction === 'next' && !this.isLastFocusedElement(activeElement) ||
                    direction === 'previous' && !this.isFirstFocusedElement(activeElement)) {
                    e.preventDefault();
                    this.setNextFocusSubMenuElement(activeElement, direction);
                } else {
                    this.activeMainMenuItem = null;
                    this._hideAllSubMenu();
                }
                break;
            case 'ArrowRight':
                if (this.activeMainMenuItem) {
                    e.preventDefault();
                    this.setNextFocusMenuElement(
                        this.activeMainMenuItem,
                        'next'
                    );
                }
                break;
            case 'ArrowLeft':
                if (this.activeMainMenuItem) {
                    e.preventDefault();
                    this.setNextFocusMenuElement(
                        this.activeMainMenuItem,
                        'previous'
                    );
                }
                break;
        }
    }

    _flattenMenu(menuItems, menuLevel) {
        const result = [];
        let subMenuItems = [];
        Array.from(menuItems).forEach((item) => {
            result.push(item);
            let subMenu;
            switch (menuLevel) {
                case 'Level1':
                    subMenu = $(item.parentNode).find('.js-slider-level2-link > a, li > a, .js-banner-category-wrap .b-banner__category-wrap a'); // .b-banner__category-wrap a
                    if (subMenu.length > 0) {
                        subMenuItems = this._flattenMenu(subMenu, 'Level2');
                        result.push(...subMenuItems);
                    }
                    break;
                case 'Level2':
                    subMenu = $(item.parentNode.parentNode).find('.js-slider-level3-link > a');
                    if (subMenu.length > 0) {
                        subMenuItems = this._flattenMenu(subMenu, 'Level3');
                        result.push(...subMenuItems);
                    }
                    break;
            }
        });
        return result;
    }

    updateFlattenMenu(activeElement) {
        this.cache.flattenMenu = this._flattenMenu([activeElement], 'Level1');
        this.activeMainMenuItem = activeElement;
    }

    selectNextFocusMenuElement(activeElement, direction) {
        const menuItems = this.cache.rootMenuItems;
        const currentIndex = this.getActiveMenuIndex(menuItems, activeElement);
        const nextIndex =
            direction === 'next'
                ? (currentIndex + 1) % menuItems.length
                : (currentIndex - 1 + menuItems.length) % menuItems.length;
        const nextElement = menuItems[nextIndex];
        this.updateFlattenMenu(nextElement);
        this.onRootHover(nextElement.parentNode);
        return nextElement;
    }

    setNextFocusMenuElement(activeElement, direction) {
        const nextElement = this.selectNextFocusMenuElement(activeElement, direction);
        nextElement.focus();
    }

    setNextFocusSubMenuElement(activeElement, direction) {
        let menuItems = this.cache.flattenMenu;
        let currentIndex = this.getActiveMenuIndex(menuItems, activeElement);
        let nextIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1;

        if (nextIndex < 0 || nextIndex >= menuItems.length) {
            this.selectNextFocusMenuElement(menuItems[0], direction);
            menuItems = this.cache.flattenMenu;
            nextIndex = 0; // Wrap around to the beginning
        }

        const nextElement = menuItems[nextIndex];

        nextElement.focus();
    }

    getActiveMenuIndex(menuItems, activeElement) {
        return Array.from(menuItems).indexOf(activeElement);
    }

    isFirstFocusedElement(activeElement) {
        return this.getActiveMenuIndex(this.cache.rootMenuItems, activeElement) === 0;
    }

    isLastFocusedElement(activeElement) {
        return (this.getActiveMenuIndex(this.cache.rootMenuItems, this.cache.flattenMenu[0]) === this.cache.rootMenuItems.length - 1) &&
            (this.getActiveMenuIndex(this.cache.flattenMenu, activeElement) === this.cache.flattenMenu.length - 1);
    }
}

module.exports = NavigationMenu;
